import React from 'react';
import { Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ZapIcon } from '../../../assets/icons/svg/shared/ic-shared-zap.svg';

interface LimitsHigherButtonProps {
  handleOpenLimitsModal: () => void;
}
export const LimitsHigherButton = ({ handleOpenLimitsModal }: LimitsHigherButtonProps) => {
  const { t } = useTranslation('limitsEN');
  return (
    <>
      <ZapIcon className='w-[18px] h-[18px] mr-[2px]' />
      <Text.H10>{t('NEED_HIGHER')}</Text.H10>
      <button
        type='button'
        disabled={false}
        onClick={handleOpenLimitsModal}
        id='NEED_HIGHER'
        className='btn-link text-action03 underline w-fit ml-[8px] z-99999'
      >
        {t('APPLY_FOR_HIGHER_BUTTON')}
      </button>
    </>
  );
};
